module.exports = __webpack_public_path__ + "static/img/logo1.37508d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo1.png
// module id = 7XU5
// module chunks = 0